import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RequestErrorLogDataI } from 'src/app/pages/log-analysis/interface/rowDataResponse';

@Injectable({
    providedIn: 'root',
})
export class LogAnalysisService {
    private apiServiceUrl = environment.apiUrl;
    private selectedErrorDetail!:RequestErrorLogDataI;
    deleteLogAnalysis = new BehaviorSubject<any>(null);

    constructor(private http: HttpClient) {}

    public setSelectedErrorDetail(row:RequestErrorLogDataI){
        this.selectedErrorDetail = row;
    }

    public getSelectedRow(){
        return this.selectedErrorDetail;
    }

    public getLogRequestList(): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/log/analysis/api/requestList`;
        return this.http.get(url);
    }

    public getLogAnalysisReport(requestId: string): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/log/analysis/api/report`;
        return this.http.get(url, { params: { requestId } });
    }

    public uploadFile(clientName: string, file: File, teamName: string, prompt: string): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('clientName', clientName);
        formData.append('file', file, file.name);
        formData.append('teamName', teamName);
        formData.append('prompt', prompt);
        const url = `${this.apiServiceUrl}/aipo/log/analysis/api/upload`;
        return this.http.post(url, formData);
    }

    public deleteLogAnalsisRecord(requestId:number){
        const apiUrl=`${this.apiServiceUrl}/aipo/log/analysis/api/request/${requestId}`;
        return this.http.delete(apiUrl)

    }
    public generateRecommendation(errorMessage: string): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/log/analysis/api/recommendation/generate`;
        const body = { errorMessage };
        return this.http.post(url, body);
    }
}
